import { IGridElement, IRowValidation } from '../../types';
import { getValidationData } from './getValidationData';
import { validationMessages } from './validationMessages';

export const validateDuplicateRows = (
  grid: IGridElement[][],
  validation: IRowValidation[]
) => {
  const rowsAsData = grid.map((row, index) => ({
    index,
    value: getValidationData(row),
  }));
  const dupeIndices = rowsAsData
    .filter((row, index) => {
      const possibleDupe = rowsAsData.find(
        (r, i) => r.value === row.value && i !== index
      );
      return possibleDupe;
    })
    .map((d) => d.index);
  return validation.map((v, index) => {
    const isDupe = dupeIndices.includes(index);
    const hasMessage = v.messages.includes(validationMessages.DUPLICATE);
    let messages = v.messages;

    if (isDupe) {
      if (!hasMessage) {
        messages = [validationMessages.DUPLICATE, ...v.messages];
      }
    } else {
      messages = v.messages.filter((m) => m !== validationMessages.DUPLICATE);
    }
    return {
      ...v,
      messages,
    };
  });
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/validateDuplicateRows.ts